/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts"
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_PlayerPrint_PlayerPrint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/PlayerPrint/PlayerPrint */ "./resources/scripts/components/PlayerPrint/PlayerPrint.ts");
/* harmony import */ var _components_GiftWithProduct_GiftWithProduct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/GiftWithProduct/GiftWithProduct */ "./resources/scripts/components/GiftWithProduct/GiftWithProduct.ts");
/* harmony import */ var _components_InventoryInfo_InventoryInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @components/InventoryInfo/InventoryInfo */ "./resources/scripts/components/InventoryInfo/InventoryInfo.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable */



customElements.define('player-print', _components_PlayerPrint_PlayerPrint__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define('inventory-info', _components_InventoryInfo_InventoryInfo__WEBPACK_IMPORTED_MODULE_2__["default"]);
var giftWithProduct = new _components_GiftWithProduct_GiftWithProduct__WEBPACK_IMPORTED_MODULE_1__["default"]();
giftWithProduct.init();
function fetchProductAndUpdateButton() {
  return _fetchProductAndUpdateButton.apply(this, arguments);
}
function _fetchProductAndUpdateButton() {
  _fetchProductAndUpdateButton = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
    var productUrl, response, data, variants, selectedVariant, wishlistButton, localWishlistItems, wishlistItems, newAttributes, attributesObject, exists, _t4;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          productUrl = window.productUrl;
          console.log(productUrl);
          _context4.p = 1;
          _context4.n = 2;
          return fetch("".concat(productUrl, ".json"));
        case 2:
          response = _context4.v;
          _context4.n = 3;
          return response.json();
        case 3:
          data = _context4.v;
          if (response.ok) {
            variants = data.product.variants; // get the selected variant based on the currenty url - Checking for ?=variant and splitting the url to get the variant id
            selectedVariant = variants.filter(function (variant) {
              return window.location.href.includes("variant=".concat(variant.id));
            }); // update the wishlist button with the new variant
            wishlistButton = document.querySelector('wishlist-button');
            wishlistButton.dataset.title = "".concat(data.product.title);
            wishlistButton.dataset.id = selectedVariant[0].id;
            wishlistButton.dataset.price = selectedVariant[0].price;
            // check if the wishlist button attributes
            localWishlistItems = localStorage.getItem('wishlistItems');
            wishlistItems = JSON.parse(localWishlistItems);
            newAttributes = wishlistButton.dataset;
            attributesObject = Object.assign({}, newAttributes);
            exists = wishlistItems === null || wishlistItems === void 0 ? void 0 : wishlistItems.some(function (item) {
              return item.id === attributesObject.id;
            });
            if (!exists) {
              wishlistButton.classList.remove('is-animating');
            } else {
              wishlistButton.classList.add('is-animating');
            }
          }
          if (response.ok) {
            _context4.n = 4;
            break;
          }
          console.log(response);
          throw new Error('Network response was not ok');
        case 4:
          _context4.n = 6;
          break;
        case 5:
          _context4.p = 5;
          _t4 = _context4.v;
          console.log(_t4);
        case 6:
          _context4.p = 6;
          return _context4.f(6);
        case 7:
          return _context4.a(2);
      }
    }, _callee4, null, [[1, 5, 6, 7]]);
  }));
  return _fetchProductAndUpdateButton.apply(this, arguments);
}
function getCart() {
  return _getCart.apply(this, arguments);
} // function to add wishlist item to the cart
function _getCart() {
  _getCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    var response, data, itemCount, cartDrawer, _t5;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          _context5.p = 0;
          _context5.n = 1;
          return fetch('/cart.js');
        case 1:
          response = _context5.v;
          if (!response.ok) {
            _context5.n = 3;
            break;
          }
          _context5.n = 2;
          return response.json();
        case 2:
          data = _context5.v;
          itemCount = data.item_count;
          if (itemCount == 1) {
            window.location.reload();
          } else {
            cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
            cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
              bubbles: false
            }));
            document.dispatchEvent(new CustomEvent('theme:cart:reload', {
              bubbles: true
            }));
          }
        case 3:
          if (response.ok) {
            _context5.n = 4;
            break;
          }
          console.log(response);
          throw new Error('Network response was not ok');
        case 4:
          _context5.n = 6;
          break;
        case 5:
          _context5.p = 5;
          _t5 = _context5.v;
          console.log(_t5);
        case 6:
          _context5.p = 6;
          return _context5.f(6);
        case 7:
          return _context5.a(2);
      }
    }, _callee5, null, [[0, 5, 6, 7]]);
  }));
  return _getCart.apply(this, arguments);
}
function AddToCart(_x) {
  return _AddToCart.apply(this, arguments);
} // function to render wishlist items. It is called in the connectedCallback of the WishlistElementsWrapper class and in the remove item class
function _AddToCart() {
  _AddToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(FormData) {
    var response, data, _t6;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          _context6.p = 0;
          _context6.n = 1;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(FormData)
          });
        case 1:
          response = _context6.v;
          if (!response.ok) {
            _context6.n = 3;
            break;
          }
          _context6.n = 2;
          return response.json();
        case 2:
          data = _context6.v;
        case 3:
          if (response.ok) {
            _context6.n = 4;
            break;
          }
          console.log(response);
          throw new Error('Network response was not ok');
        case 4:
          _context6.n = 6;
          break;
        case 5:
          _context6.p = 5;
          _t6 = _context6.v;
          console.log(_t6);
        case 6:
          _context6.p = 6;
          // call the getcart function
          getCart();
          return _context6.f(6);
        case 7:
          return _context6.a(2);
      }
    }, _callee6, null, [[0, 5, 6, 7]]);
  }));
  return _AddToCart.apply(this, arguments);
}
function renderWishList(_x2) {
  return _renderWishList.apply(this, arguments);
} // function to render the wishlist module
function _renderWishList() {
  _renderWishList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(wishlistItems) {
    var itemHTML, _iterator5, _step5, item, handle, productUrl, status, text, availability, color, _t7;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          console.log(wishlistItems);
          itemHTML = '';
          _iterator5 = _createForOfIteratorHelper(wishlistItems);
          _context7.p = 1;
          _iterator5.s();
        case 2:
          if ((_step5 = _iterator5.n()).done) {
            _context7.n = 5;
            break;
          }
          item = _step5.value;
          handle = item.handle;
          productUrl = "/products/".concat(handle); // api call to get the newest product data
          _context7.n = 3;
          return getProductData(productUrl, item.id);
        case 3:
          status = _context7.v;
          text = void 0;
          availability = void 0;
          color = void 0;
          text = status ? 'Tilføj til kurv' : 'Udsolgt';
          availability = status ? '' : 'disabled';
          color = status ? 'tw-bg-[#196450]' : 'tw-bg-[#6b6b6b]';
          itemHTML += "<a href=\"".concat(item.url, "\" data-id=\"").concat(item.id, "\" data-handle=\"").concat(item.handle, "\" class=\"wishlist-item\">\n      <div class=\"wishlist-item-info tw-text-center\">\n        <div class=\"tw-relative\">\n          <img class=\"tw-object-contain\" style=\"--wh-ratio: 1.0;\" src=\"").concat(item.images, "\" alt=\"").concat(item.title, "\" />\n          <wishlist-add_to_cart data-id=\"").concat(item.id, "\">\n            <button class=\"tw-absolute tw-text-[13px] tw-uppercase tw-tracking-[1px] tw-font-bold ").concat(color, " tw-px-[24px] tw-py-[12px] tw-text-white tw-w-full tw-flex tw-justify-center tw-bottom-0 tw-text-center\" ").concat(availability, ">").concat(text, "</button>\n          </wishlist-add_to_cart>\n          </div>\n        <h3 class=\"tw-text-[14.5px] tw-font-bold !tw-m-0 tw-py-2\">").concat(item.title, "</h3>\n        <p class=\"tw-text-[13px]\">").concat(item.price, " DKK</p>\n        <remove-item class=\"remove-item tw-cursor-pointer tw-text-[12px] tw-underline\">Fjern</remove-item>\n      </div>\n    </a>");
        case 4:
          _context7.n = 2;
          break;
        case 5:
          _context7.n = 7;
          break;
        case 6:
          _context7.p = 6;
          _t7 = _context7.v;
          _iterator5.e(_t7);
        case 7:
          _context7.p = 7;
          _iterator5.f();
          return _context7.f(7);
        case 8:
          return _context7.a(2, itemHTML);
      }
    }, _callee7, null, [[1, 6, 7, 8]]);
  }));
  return _renderWishList.apply(this, arguments);
}
function renderWishlistModule() {
  var localWishlistItems = localStorage.getItem('wishlistItems');
  var wishlistItems;
  if (localWishlistItems) {
    wishlistItems = JSON.parse(localWishlistItems);
  } else {
    wishlistItems = [];
  }
  setTimeout(function () {
    var wishlistModule = Array.from(document.querySelectorAll('.wishlist-module'));
    var wishlistSection = Array.from(document.querySelectorAll('.wishlist-section'));
    console.log(wishlistItems.length);
    if (wishlistItems.length > 0) {
      var _iterator = _createForOfIteratorHelper(wishlistSection),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          item.classList.remove('tw-hidden');
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(wishlistModule),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _item = _step2.value;
          _item.classList.add('tw-hidden');
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else {
      var _iterator3 = _createForOfIteratorHelper(wishlistSection),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _item2 = _step3.value;
          _item2.classList.add('tw-hidden');
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var _iterator4 = _createForOfIteratorHelper(wishlistModule),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _item3 = _step4.value;
          _item3.classList.remove('tw-hidden');
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, 1000);
  setTimeout(function () {
    var wishlistCount = document.querySelector('#wishlistCount');
    wishlistCount.innerHTML = wishlistItems.length;
  }, 1500);
}
var WishlistSection = /*#__PURE__*/function (_HTMLElement) {
  function WishlistSection() {
    _classCallCheck(this, WishlistSection);
    return _callSuper(this, WishlistSection);
  }
  _inherits(WishlistSection, _HTMLElement);
  return _createClass(WishlistSection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      renderWishlistModule();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('wishlist-section', WishlistSection);
var WishlistButton = /*#__PURE__*/function (_HTMLElement2) {
  function WishlistButton() {
    _classCallCheck(this, WishlistButton);
    return _callSuper(this, WishlistButton);
  }
  _inherits(WishlistButton, _HTMLElement2);
  return _createClass(WishlistButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      var localWishlistItems = localStorage.getItem('wishlistItems');
      var attributes = this.dataset;
      if (localWishlistItems) {
        var wishlistItems = JSON.parse(localWishlistItems);
        var attributesObject = Object.assign({}, attributes);
        var exists = wishlistItems === null || wishlistItems === void 0 ? void 0 : wishlistItems.some(function (item) {
          return item.id === attributesObject.id;
        });
        // on dom load check if the item exists in the wishlistItems array if it does add the is-animating class to show that the item is already in the wishlist
        if (exists) {
          this.classList.toggle('is-animating');
        }
      }
      setTimeout(function () {
        // on click toggle the is-animating class and add or remove the item from the wishlistItems array based on if it exists or not
        _this.addEventListener('click', function () {
          _this.classList.toggle('is-animating');
          var wishlistModuleBox = document.querySelector('#wishlist-module-box');
          var wishlistModuleImg = wishlistModuleBox.querySelector('#wishlist-module-img');
          var wishlistModuleTitle = wishlistModuleBox.querySelector('#wishlist-module-title');
          var wishlistModuleText = wishlistModuleBox.querySelector('#wishlist-module-text');
          wishlistModuleBox.classList.toggle('randomClassName');
          setTimeout(function () {
            wishlistModuleBox.classList.toggle('randomClassName');
          }, 3000);
          if (localWishlistItems) {
            console.log('localWishlistItems exists');
            // add new object to the wishlistItems array
            var _wishlistItems = JSON.parse(localWishlistItems);
            var _attributesObject = Object.assign({}, attributes);
            var _exists = _wishlistItems === null || _wishlistItems === void 0 ? void 0 : _wishlistItems.some(function (item) {
              return item.id === _attributesObject.id;
            });
            wishlistModuleImg.setAttribute('src', _attributesObject.images);
            wishlistModuleTitle.innerHTML = _attributesObject.title;
            if (!_exists) {
              // add attributes to the wishlistItems array
              _wishlistItems.push(_attributesObject);
              localStorage.setItem('wishlistItems', JSON.stringify(_wishlistItems));
              wishlistModuleText.innerHTML = 'Tilføjet til ønskeliste';
            } else {
              // remove attributes from the wishlistItems array
              var newWishlistItems = _wishlistItems.filter(function (item) {
                return item.id != _attributesObject.id;
              });
              localStorage.setItem('wishlistItems', JSON.stringify(newWishlistItems));
              wishlistModuleText.innerHTML = 'Fjernet fra ønskeliste';
            }
          } else {
            console.log('localWishlistItems does not exist');
            var _wishlistItems2 = [];
            var _attributesObject2 = Object.assign({}, attributes);
            _wishlistItems2.push(_attributesObject2);
            localStorage.setItem('wishlistItems', JSON.stringify(_wishlistItems2));
            wishlistModuleText.innerHTML = 'Tilføjet til ønskeliste';
            wishlistModuleImg.setAttribute('src', _attributesObject2.images);
            wishlistModuleTitle.innerHTML = _attributesObject2.title;
            _wishlistItems2.push(_attributesObject2);
            // update localStorage with the new wishlistItems array
            localStorage.setItem('wishlistItems', JSON.stringify(_wishlistItems2));
          }
          localWishlistItems = localStorage.getItem('wishlistItems');
        });
        // listen for variant change and update the wishlist button and it's attributes - THIS IS HIGHLY DEPENDENT ON THE THEME AND MUST BE UPDATED BASED ON THE THEME
        // The below code is for the theme "Pipeline"
        var fieldSet = document.querySelector('fieldset');
        fieldSet.addEventListener('change', function () {
          // fetch the product
          fetchProductAndUpdateButton();
        });
      }, 1000);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('wishlist-button', WishlistButton);
var WishlistElementsWrapper = /*#__PURE__*/function (_HTMLElement3) {
  function WishlistElementsWrapper() {
    _classCallCheck(this, WishlistElementsWrapper);
    return _callSuper(this, WishlistElementsWrapper);
  }
  _inherits(WishlistElementsWrapper, _HTMLElement3);
  return _createClass(WishlistElementsWrapper, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var localWishlistItems, wishlistItems, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              localWishlistItems = localStorage.getItem('wishlistItems');
              wishlistItems = JSON.parse(localWishlistItems);
              _t = "\n        <div class=\"item-container tw-w-full\">\n          <div class=\"tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-5 tw-py-[50px]\">\n          ";
              _context.n = 1;
              return renderWishList(wishlistItems);
            case 1:
              this.innerHTML = _t.concat.call(_t, _context.v, "\n          </div>\n        </div>\n      ");
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('wishlist-elements-wrapper', WishlistElementsWrapper);
// remove item from wishlist
var RemoveItem = /*#__PURE__*/function (_HTMLElement4) {
  function RemoveItem() {
    _classCallCheck(this, RemoveItem);
    return _callSuper(this, RemoveItem);
  }
  _inherits(RemoveItem, _HTMLElement4);
  return _createClass(RemoveItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var remove_item = document.querySelectorAll('.remove-item');
      remove_item.forEach(function (item) {
        item.addEventListener('click', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
            var localWishlistItems, wishlistItems, id, newWishlistItems, wishlistElementsWrapper, _t2;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  event.preventDefault();
                  localWishlistItems = localStorage.getItem('wishlistItems');
                  wishlistItems = JSON.parse(localWishlistItems);
                  id = item.parentElement.parentElement.dataset.id;
                  newWishlistItems = wishlistItems.filter(function (item) {
                    return item.id != id;
                  });
                  localStorage.setItem('wishlistItems', JSON.stringify(newWishlistItems));
                  wishlistElementsWrapper = document.querySelector('wishlist-elements-wrapper');
                  _t2 = "\n            <div class=\"item-container tw-w-full\">\n              <div class=\"tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-5 tw-py-[50px]\">\n                ";
                  _context2.n = 1;
                  return renderWishList(newWishlistItems);
                case 1:
                  wishlistElementsWrapper.innerHTML = _t2.concat.call(_t2, _context2.v, "\n              </div>\n            </div>\n          ");
                  renderWishlistModule();
                case 2:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x3) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('remove-item', RemoveItem);
var WishlistAddToCart = /*#__PURE__*/function (_HTMLElement5) {
  function WishlistAddToCart() {
    _classCallCheck(this, WishlistAddToCart);
    return _callSuper(this, WishlistAddToCart);
  }
  _inherits(WishlistAddToCart, _HTMLElement5);
  return _createClass(WishlistAddToCart, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var addToCart = this.querySelector('button');
      addToCart.addEventListener('click', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
          var FormData, localWishlistItems, wishlistItems, itemToRemove, wishlistElementsWrapper, _t3;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                event.preventDefault();
                FormData = {
                  items: [{
                    id: _this2.dataset.id,
                    quantity: 1
                  }]
                };
                AddToCart(FormData);
                // remove the item from the wishlistItems
                localWishlistItems = localStorage.getItem('wishlistItems');
                wishlistItems = JSON.parse(localWishlistItems);
                itemToRemove = wishlistItems.filter(function (item) {
                  return item.id != _this2.dataset.id;
                });
                localStorage.setItem('wishlistItems', JSON.stringify(itemToRemove));
                // update the wishlist elements wrapper
                wishlistElementsWrapper = document.querySelector('wishlist-elements-wrapper'); // remove item after 1 second
                _t3 = "\n          <div class=\"item-container tw-w-full\">\n            <div class=\"tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-5 tw-py-[50px]\">\n              ";
                _context3.n = 1;
                return renderWishList(itemToRemove);
              case 1:
                wishlistElementsWrapper.innerHTML = _t3.concat.call(_t3, _context3.v, "\n            </div>\n          </div>\n        ");
                renderWishlistModule();
              case 2:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('wishlist-add_to_cart', WishlistAddToCart);
function getProductData(_x5, _x6) {
  return _getProductData.apply(this, arguments);
}
function _getProductData() {
  _getProductData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(url, variantId) {
    var response, data, variants, selectedVariant, status, _t8;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.p = _context8.n) {
        case 0:
          _context8.p = 0;
          _context8.n = 1;
          return fetch("".concat(url, ".js"));
        case 1:
          response = _context8.v;
          if (!response.ok) {
            _context8.n = 3;
            break;
          }
          _context8.n = 2;
          return response.json();
        case 2:
          data = _context8.v;
          variants = data.variants;
          selectedVariant = variants.filter(function (variant) {
            return variant.id == variantId;
          }); // Get get the selected variants availability status
          status = selectedVariant[0].available;
          return _context8.a(2, status);
        case 3:
          console.log(response);
        case 4:
          _context8.n = 6;
          break;
        case 5:
          _context8.p = 5;
          _t8 = _context8.v;
          console.log(_t8);
        case 6:
          _context8.p = 6;
          return _context8.f(6);
        case 7:
          return _context8.a(2);
      }
    }, _callee8, null, [[0, 5, 6, 7]]);
  }));
  return _getProductData.apply(this, arguments);
}
document.addEventListener('DOMContentLoaded', function () {
  var sizeGuideModal = document.getElementById('sizeguide-modal');
  var sizeGuideTriggers = Array.from(document.querySelectorAll('.sizeguide-trigger'));
  console.log(sizeGuideModal);
  console.log(sizeGuideTriggers);
  if (sizeGuideTriggers.length > 0) {
    sizeGuideTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        sizeGuideModal.classList.toggle('modal-active');
      });
    });
  }
});

/***/ },

/***/ "./resources/scripts/components/GiftWithProduct/GiftWithProduct.ts"
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/GiftWithProduct/GiftWithProduct.ts ***!
  \*************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GiftWithProduct)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
var GiftWithProduct = /*#__PURE__*/function () {
  function GiftWithProduct() {
    _classCallCheck(this, GiftWithProduct);
    _defineProperty(this, "hasTriggered", false);
    this.init = this.init.bind(this);
    this.listenForAddToCart = this.listenForAddToCart.bind(this);
    this.getGiftProduct = this.getGiftProduct.bind(this);
    this.checkForGiftInCart = this.checkForGiftInCart.bind(this);
  }
  return _createClass(GiftWithProduct, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var giftIsInCart;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.checkForGiftInCart();
            case 1:
              giftIsInCart = _context.v;
              if (giftIsInCart !== true) {
                console.log('Gift is not in cart');
                if (window.allProducts) {
                  this.listenForAddToCart();
                } else {
                  this.listenForCartChange();
                }
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "listenForAddToCart",
    value: function listenForAddToCart() {
      var originalFetch = window.fetch.bind(window);
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      function _fetch() {
        _fetch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(url, options) {
          var response, clone, data, addedProductID;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!url.includes('cart/add')) {
                  _context2.n = 4;
                  break;
                }
                _context2.n = 1;
                return originalFetch(url, options);
              case 1:
                response = _context2.v;
                clone = response.clone();
                if (!clone.ok) {
                  _context2.n = 3;
                  break;
                }
                _context2.n = 2;
                return clone.json();
              case 2:
                data = _context2.v;
                addedProductID = data.product_id;
                this.getGiftProduct(addedProductID);
              case 3:
                return _context2.a(2, response);
              case 4:
                return _context2.a(2, originalFetch(url, options));
            }
          }, _callee2, this);
        }));
        return _fetch.apply(this, arguments);
      }
      window.fetch = fetch.bind(this);
    }
  }, {
    key: "listenForCartChange",
    value: function listenForCartChange() {
      document.addEventListener('ed:cart-updated', this.checkCart.bind(this));
    }
  }, {
    key: "checkCart",
    value: function () {
      var _checkCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this = this;
        var response, data, totalCartPrice, gwpThreshold, gwpThresholdNum, giftWithProductModal, giftWithProductModalTriggers, getGiftBtn, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(sessionStorage.getItem('gwpGiftNotAdded') !== 'false')) {
                _context3.n = 6;
                break;
              }
              _context3.p = 1;
              _context3.n = 2;
              return fetch('/cart.js');
            case 2:
              response = _context3.v;
              if (!response.ok) {
                _context3.n = 4;
                break;
              }
              _context3.n = 3;
              return response.json();
            case 3:
              data = _context3.v;
              totalCartPrice = data.total_price;
              gwpThreshold = window.gwp_price;
              gwpThresholdNum = Number(gwpThreshold);
              if (totalCartPrice >= gwpThresholdNum) {
                giftWithProductModal = document.getElementById('gift-with-product-modal');
                giftWithProductModal.classList.toggle('modal-active');
                giftWithProductModalTriggers = Array.from(document.querySelectorAll('.gift-with-product-trigger'));
                giftWithProductModalTriggers.forEach(function (trigger) {
                  trigger.addEventListener('click', function () {
                    giftWithProductModal.classList.toggle('modal-active');
                  });
                });
                getGiftBtn = document.getElementById('get-gift');
                getGiftBtn.addEventListener('click', function () {
                  var formData = {
                    items: []
                  };
                  formData.items.push({
                    id: window.gift,
                    quantity: 1,
                    properties: {
                      Gave: 'Ja'
                    }
                  });
                  _this.addProducts(formData);
                  sessionStorage.setItem('gwpGiftNotAdded', 'false');
                });
              }
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t = _context3.v;
              console.error(_t);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 5]]);
      }));
      function checkCart() {
        return _checkCart.apply(this, arguments);
      }
      return checkCart;
    }()
  }, {
    key: "getGiftProduct",
    value: function () {
      var _getGiftProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(addedProductID) {
        var _this2 = this;
        var allProductsData, product, giftWithProductModal, giftWithProductModalTriggers, getGiftBtn;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!this.hasTriggered) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.hasTriggered = true;
              allProductsData = window.allProducts; // check if the added product is in the allProductsData (allProductsData is an array of all products in the store)
              product = allProductsData.find(function (product) {
                return product.productID === addedProductID;
              });
              if (product) {
                giftWithProductModal = document.getElementById('gift-with-product-modal');
                giftWithProductModal.classList.toggle('modal-active');
                giftWithProductModalTriggers = Array.from(document.querySelectorAll('.gift-with-product-trigger'));
                giftWithProductModalTriggers.forEach(function (trigger) {
                  trigger.addEventListener('click', function () {
                    giftWithProductModal.classList.toggle('modal-active');
                  });
                });
                getGiftBtn = document.getElementById('get-gift');
                getGiftBtn.addEventListener('click', function () {
                  var formData = {
                    items: []
                  };
                  formData.items.push({
                    id: window.gift,
                    quantity: 1,
                    properties: {
                      Gave: 'Ja'
                    }
                  });
                  _this2.addProducts(formData);
                });
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getGiftProduct(_x3) {
        return _getGiftProduct.apply(this, arguments);
      }
      return getGiftProduct;
    }()
  }, {
    key: "addProducts",
    value: function () {
      var _addProducts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(formData) {
        var response, giftWithProductModal, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              });
            case 1:
              response = _context5.v;
              if (response.ok) {
                giftWithProductModal = document.getElementById('gift-with-product-modal');
                giftWithProductModal.classList.toggle('modal-active');
                document.dispatchEvent(new CustomEvent('theme:cart:reload'));
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t2 = _context5.v;
              console.error(_t2);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 2]]);
      }));
      function addProducts(_x4) {
        return _addProducts.apply(this, arguments);
      }
      return addProducts;
    }()
  }, {
    key: "checkForGiftInCart",
    value: function () {
      var _checkForGiftInCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var response, data, cartItems, giftInCart, properties, _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return fetch('/cart.js');
            case 1:
              response = _context6.v;
              if (!response.ok) {
                _context6.n = 4;
                break;
              }
              _context6.n = 2;
              return response.json();
            case 2:
              data = _context6.v;
              cartItems = data.items;
              giftInCart = cartItems.find(function (item) {
                return item.id == Number(window.gift);
              });
              if (!giftInCart) {
                _context6.n = 4;
                break;
              }
              properties = giftInCart.properties;
              if (!(properties && properties.Gave === 'Ja')) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2, true);
            case 3:
              return _context6.a(2, false);
            case 4:
              _context6.n = 6;
              break;
            case 5:
              _context6.p = 5;
              _t3 = _context6.v;
              console.error(_t3);
            case 6:
              return _context6.a(2);
          }
        }, _callee6, null, [[0, 5]]);
      }));
      function checkForGiftInCart() {
        return _checkForGiftInCart.apply(this, arguments);
      }
      return checkForGiftInCart;
    }()
  }]);
}();

var giftWithProduct = new GiftWithProduct();
giftWithProduct.init();

/***/ },

/***/ "./resources/scripts/components/InventoryInfo/InventoryInfo.ts"
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/InventoryInfo/InventoryInfo.ts ***!
  \*********************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ InventoryInfo)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InventoryInfo = /*#__PURE__*/function (_HTMLElement) {
  function InventoryInfo() {
    var _this;
    _classCallCheck(this, InventoryInfo);
    _this = _callSuper(this, InventoryInfo);
    _defineProperty(_this, "productUrl", _this.dataset.producturl);
    _defineProperty(_this, "shop", _this.dataset.shop);
    _this.updateInventoryInfo = _this.updateInventoryInfo.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    return _this;
  }
  _inherits(InventoryInfo, _HTMLElement);
  return _createClass(InventoryInfo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListeners();
    }
  }, {
    key: "addEventListeners",
    value: function () {
      var _addEventListeners = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // listen for theme:variant:change
              document.addEventListener('theme:variant:change', function (event) {
                var variantId = event.detail.variant.id;
                _this2.updateInventoryInfo(variantId);
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function addEventListeners() {
        return _addEventListeners.apply(this, arguments);
      }
      return addEventListeners;
    }()
  }, {
    key: "updateInventoryInfo",
    value: function () {
      var _updateInventoryInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        var fetchUrl, response, data, parser, doc, inventoryInfo, oldInventoryInfo, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              // const fetchUrl = `${window.location.href}?section_id=main-product`;
              fetchUrl = "".concat(this.shop).concat(this.productUrl, "?variant=").concat(id, "?section_id=main-product");
              _context2.n = 1;
              return fetch("".concat(fetchUrl));
            case 1:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 2;
                break;
              }
              throw new Error('Failed to fetch inventory info');
            case 2:
              _context2.n = 3;
              return response.text();
            case 3:
              data = _context2.v;
              parser = new DOMParser();
              doc = parser.parseFromString(data, 'text/html');
              inventoryInfo = doc.querySelector('inventory-info');
              oldInventoryInfo = document.querySelector('inventory-info');
              if (inventoryInfo !== oldInventoryInfo) {
                oldInventoryInfo.replaceWith(inventoryInfo);
              }
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              console.error(_t);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 4]]);
      }));
      function updateInventoryInfo(_x) {
        return _updateInventoryInfo.apply(this, arguments);
      }
      return updateInventoryInfo;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/PlayerPrint/PlayerPrint.ts"
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/PlayerPrint/PlayerPrint.ts ***!
  \*****************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PlayerPrint)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
var PlayerPrint = /*#__PURE__*/function (_HTMLElement) {
  function PlayerPrint() {
    var _this;
    _classCallCheck(this, PlayerPrint);
    _this = _callSuper(this, PlayerPrint);
    _defineProperty(_this, "togglePlayerListElement", void 0);
    _defineProperty(_this, "playerPrintWrapper", void 0);
    _defineProperty(_this, "playerListElement", void 0);
    _defineProperty(_this, "players", void 0);
    _defineProperty(_this, "productContainer", void 0);
    _defineProperty(_this, "variantSelectors", void 0);
    _defineProperty(_this, "media", void 0);
    _defineProperty(_this, "mediaFirst", void 0);
    _defineProperty(_this, "mediaSecond", void 0);
    _defineProperty(_this, "mediaFirstSrc", void 0);
    _defineProperty(_this, "mediaSecondSrc", void 0);
    _defineProperty(_this, "selectedPlayer", void 0);
    _this.handleAddToCart = _this.handleAddToCart.bind(_this);
    return _this;
  }
  _inherits(PlayerPrint, _HTMLElement);
  return _createClass(PlayerPrint, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.defineElements();
      this.addEventListeners();
    }
  }, {
    key: "defineElements",
    value: function defineElements() {
      this.playerPrintWrapper = this.querySelector('#player-print');
      this.togglePlayerListElement = this.querySelector('#toggle_player-list');
      this.playerListElement = this.querySelector('#player-list');
      this.players = Array.from(this.querySelectorAll('.player'));
      if (this.togglePlayerListElement) {
        this.togglePlayerListElement.style.borderBottom = '1px solid #E3E3E3';
      }
      this.productContainer = this.closest('.product-section');
      this.variantSelectors = Array.from(this.querySelectorAll('.player_print-option'));
      this.media = Array.from(this.productContainer.querySelectorAll('.product__media'));
      this.mediaFirst = this.media[0].querySelector('img');
      this.mediaSecond = this.media[1].querySelector('img');
      this.mediaFirstSrc = this.mediaFirst.getAttribute('src');
      this.mediaSecondSrc = this.mediaSecond.getAttribute('src');
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      document.addEventListener('playerPrintDeselected', function () {
        _this2.selectedPlayer = null;
        // disable media change until data is updated with images
        // this.toggleMedia(false);
      });
      this.togglePlayerListElement.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.togglePlayerList();
      });
      this.players.forEach(function (player) {
        player.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handlePlayerSelection(player);
        });
      });
      this.variantSelectors.forEach(function (selector) {
        selector.addEventListener('change', function (event) {
          _this2.handleVariantChange(event);
        });
      });
      // Add event listener for the add to cart button
      var addToCartButton = this.productContainer.querySelector('[data-add-to-cart]');
      console.log('Add to cart button found:', addToCartButton); // Debug log for button element
      if (addToCartButton) {
        console.log('Adding click listener to add to cart button'); // Debug log before adding listener
        addToCartButton.addEventListener('click', function (event) {
          console.log('Add to cart button clicked!'); // Debug log for click event
          setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return _this2.handleAddToCart();
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          })), 500);
        });
      } else {
        console.log('Add to cart button not found!'); // Debug log if button not found
      }
    }
  }, {
    key: "togglePlayerList",
    value: function togglePlayerList() {
      this.playerListElement.classList.toggle('active');
      var arrowDown = this.togglePlayerListElement.querySelector('.lucide-chevron-down');
      var arrowUp = this.togglePlayerListElement.querySelector('.lucide-chevron-up');
      var playerListTextElement = this.togglePlayerListElement.querySelector('#toggle_player-list-text');
      var defaultText = playerListTextElement.getAttribute('data-text') || 'Vælg spiller';
      arrowDown.classList.toggle('tw-hidden');
      arrowUp.classList.toggle('tw-hidden');
      if (this.playerListElement.classList.contains('active')) {
        this.togglePlayerListElement.style.borderBottom = '1px solid #E3E3E3';
        playerListTextElement.textContent = defaultText;
      } else {
        this.togglePlayerListElement.style.borderBottom = 'none';
        if (this.selectedPlayer) {
          console.log('Selected player:', this.selectedPlayer); // Debug log for selected player
          var playerName = this.selectedPlayer.dataset.name;
          var playerNumber = this.selectedPlayer.dataset.number;
          var playerDisplay = playerNumber ? "".concat(playerNumber, ". ").concat(playerName) : playerName;
          playerListTextElement.textContent = playerDisplay;
        }
      }
    }
  }, {
    key: "handlePlayerSelection",
    value: function handlePlayerSelection(player) {
      this.players.forEach(function (p) {
        p.classList.remove('selected');
      });
      player.classList.add('selected');
      this.selectedPlayer = player;
      // disable media change until data is updated with images
      // this.toggleMedia(true);
      this.togglePlayerList();
    }
  }, {
    key: "handleVariantChange",
    value: function handleVariantChange(event) {
      var target = event.target;
      var value = target.value;
      var printVariantSelected = value === 'player';
      printVariantSelected ? this.playerPrintWrapper.classList.remove('tw-hidden') : this.playerPrintWrapper.classList.add('tw-hidden');
      // disable media change until data is updated with images
      // this.toggleMedia(printVariantSelected);
    }
  }, {
    key: "toggleMedia",
    value: function toggleMedia(printVariantSelected) {
      if (!printVariantSelected) {
        this.mediaFirst.setAttribute('src', this.mediaFirstSrc);
        this.mediaFirst.setAttribute('srcset', this.mediaFirstSrc);
        this.mediaSecond.setAttribute('src', this.mediaSecondSrc);
        this.mediaSecond.setAttribute('srcset', this.mediaSecondSrc);
      }
      if (printVariantSelected && this.selectedPlayer) {
        var firstMediaPlayer = this.selectedPlayer.dataset.frontimage;
        var secondMediaPlayer = this.selectedPlayer.dataset.backimage;
        this.mediaFirst.setAttribute('src', firstMediaPlayer);
        this.mediaFirst.setAttribute('srcset', firstMediaPlayer);
        this.mediaSecond.setAttribute('src', secondMediaPlayer);
        this.mediaSecond.setAttribute('srcset', secondMediaPlayer);
      }
    }
  }, {
    key: "handleAddToCart",
    value: function () {
      var _handleAddToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$productContaine, _this$productContaine2, playerName, playerNumber, variantId, productTitle, selectedSize, formData, response, data, errorText, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.selectedPlayer) {
                _context2.n = 1;
                break;
              }
              console.log('No player selected'); // Debug log for no player case
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              playerName = this.selectedPlayer.dataset.name;
              playerNumber = this.selectedPlayer.dataset.number;
              variantId = this.selectedPlayer.dataset.variantid;
              productTitle = (_this$productContaine = this.productContainer.querySelector('.product__title')) === null || _this$productContaine === void 0 || (_this$productContaine = _this$productContaine.textContent) === null || _this$productContaine === void 0 ? void 0 : _this$productContaine.trim(); // Get the selected size from data-option-value
              selectedSize = (_this$productContaine2 = this.productContainer.querySelector('[data-option-value]').textContent) === null || _this$productContaine2 === void 0 ? void 0 : _this$productContaine2.trim();
              formData = {
                items: [{
                  id: variantId,
                  quantity: 1,
                  properties: {
                    //Spiller: playerNumber + ' ' + playerName,
                    'Tilhørende trøje': productTitle || 'Unknown',
                    Størrelse: selectedSize
                  }
                }]
              };
              console.log('Adding to cart:', formData);
              _context2.n = 2;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              });
            case 2:
              response = _context2.v;
              if (!response.ok) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return response.json();
            case 3:
              data = _context2.v;
              console.log('Cart response:', data);
              document.dispatchEvent(new CustomEvent('theme:cart:reload', {
                bubbles: true
              }));
              _context2.n = 6;
              break;
            case 4:
              console.error('Failed to add to cart. Status:', response.status);
              _context2.n = 5;
              return response.text();
            case 5:
              errorText = _context2.v;
              console.error('Error response:', errorText);
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t = _context2.v;
              console.error('Error adding items to cart:', _t);
              if (_t instanceof Error) {
                console.error('Error details:', _t.message);
              }
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 7]]);
      }));
      function handleAddToCart() {
        return _handleAddToCart.apply(this, arguments);
      }
      return handleAddToCart;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/styles/app.css"
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkklovershoppen"] = self["webpackChunkklovershoppen"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;